import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Phone, Euro, BookOpen } from 'lucide-react';
import Breadcrumbs from '../components/Breadcrumbs';
import { seoData } from '../data/seoData';
import { stadtteile } from '../data/stadtteile';

const EinsatzgebietePage = () => {
  const seo = seoData['/einsatzgebiete/'];
  const phone = '+4923139085116';
  const displayPhone = '0231 39085116';
  
  return (
    <>
      <Helmet>
        <title>{seo.title}</title>
        <meta name="description" content={seo.description} />
        <link rel="canonical" href="https://schluesseldienst.services/einsatzgebiete/" />
      </Helmet>
      
      <div className="container mx-auto px-4 py-12">
        <Breadcrumbs items={[{ label: 'Einsatzgebiete' }]} />
        
        <h1 className="text-4xl sm:text-5xl font-bold mb-8">Unsere Einsatzgebiete in Dortmund</h1>
        
        <div className="max-w-4xl">
          <div className="bg-orange-50 border-l-4 border-orange-600 p-6 mb-12">
            <p className="text-lg">
              Wir sind in allen Dortmunder Stadtteilen schnell für Sie da. Unsere Zentrale befindet sich in der 
              <strong> Neben dem Brand 10, 44135 Dortmund</strong>. Von hier erreichen wir Sie in der Regel innerhalb 
              von 15-30 Minuten.
            </p>
          </div>

          <h2 className="text-3xl font-bold mb-6">Alle Stadtteile im Überblick</h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-12">
            {stadtteile.sort((a, b) => a.name.localeCompare(b.name)).map((st) => (
              <Link
                key={st.slug}
                to={`/schluesseldienst-dortmund-${st.slug}/`}
                className="bg-white hover:bg-orange-50 rounded-lg shadow p-4 transition-colors border border-gray-200 hover:border-orange-300"
              >
                <h3 className="font-bold text-lg mb-1">{st.name}</h3>
                <p className="text-sm text-gray-600">PLZ: {st.plz.join(', ')}</p>
              </Link>
            ))}
          </div>

          {/* Info Box */}
          <div className="bg-white rounded-lg shadow p-6 mb-8">
            <h2 className="text-2xl font-bold mb-4">Warum wir in ganz Dortmund schnell sind</h2>
            <ul className="space-y-3">
              <li className="flex gap-3">
                <span className="text-orange-600 font-bold">✓</span>
                <span>Zentrale Lage unserer Einsatzzentrale für optimale Erreichbarkeit</span>
              </li>
              <li className="flex gap-3">
                <span className="text-orange-600 font-bold">✓</span>
                <span>Mehrere Techniker-Teams für parallele Einsätze</span>
              </li>
              <li className="flex gap-3">
                <span className="text-orange-600 font-bold">✓</span>
                <span>GPS-gestützte Navigation für die schnellste Route</span>
              </li>
              <li className="flex gap-3">
                <span className="text-orange-600 font-bold">✓</span>
                <span>24/7 Bereitschaft auch an Sonn- und Feiertagen</span>
              </li>
            </ul>
          </div>

          {/* CTA & Internal Links */}
          <div className="bg-gradient-to-br from-orange-50 to-amber-50 rounded-2xl p-8 border-2 border-orange-200">
            <h2 className="text-2xl font-bold mb-4 text-center text-gray-900">Jetzt anrufen und Termin vereinbaren</h2>
            <p className="text-center text-gray-700 mb-6">
              Transparente Festpreise • Keine Anfahrtskosten • Schnelle Hilfe
            </p>
            <div className="flex justify-center mb-6">
              <a
                href={`tel:${phone}`}
                className="bg-orange-600 hover:bg-orange-700 text-white px-8 py-4 rounded-full font-bold text-lg transition-all shadow-lg hover:shadow-xl flex items-center gap-2"
              >
                <Phone size={24} />
                {displayPhone}
              </a>
            </div>
            <div className="flex flex-wrap justify-center gap-4">
              <Link
                to="/preise"
                className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full text-sm font-semibold text-gray-700 hover:bg-orange-600 hover:text-white transition-all shadow hover:shadow-md"
              >
                <Euro size={18} />
                Preise ansehen
              </Link>
              <Link
                to="/ratgeber"
                className="inline-flex items-center gap-2 bg-white px-6 py-3 rounded-full text-sm font-semibold text-gray-700 hover:bg-orange-600 hover:text-white transition-all shadow hover:shadow-md"
              >
                <BookOpen size={18} />
                Ratgeber lesen
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EinsatzgebietePage;
